import { logAmplitudeEvent } from 'amplitude/amplitude'
import { useNotify, useTranslate } from 'ra-core'
import { useEffect, useState } from 'react'
import restClient from 'restClient'
import { DisclosuresResponseType, FormJSONType, HostedDisclosureType, ProjectPreviewForApplicationType } from '../types'

const restClientInstance = restClient(window.API_ROOT + '/api')

export const parseIncome = (formatted: string) => {
  if (!formatted) return undefined
  else {
    let justNumbers = formatted.replace(/[^0-9,$]/g, '')
    if (justNumbers.length > 0) {
      justNumbers = justNumbers.substring(0, 9)
    }
    return justNumbers
  }
}

export const parseSSN = (formatted: string) => {
  if (!formatted) return undefined
  else {
    let justNumbers = formatted.replace(/[^0-9]/g, '')
    if (justNumbers.length > 0) {
      justNumbers = justNumbers.substring(0, 9)
    }
    return justNumbers
  }
}

export const formatSSN = (ssn: string) => {
  if (!ssn) return null
  ssn = ssn.replace(/[^\d]/g, '')

  if (ssn.length > 0) {
    let chunk1 = ssn.substring(0, 3)
    let chunk2 = ssn.substring(3, 5)
    let chunk3 = ssn.substring(5)
    if (chunk1 && chunk2 && chunk3) {
      return `${chunk1}-${chunk2}-${chunk3}`
    } else if (chunk1 && chunk2) {
      return `${chunk1}-${chunk2}`
    } else return chunk1
  }
  return null
}

export const useGetApplicationDisclosures = (
  orgId: number,
  projectId: number,
  systemUuid: string,
  paymentOptionId: number,
  existingDisclosures: HostedDisclosureType[] | null | undefined,
  integration: string,
  setIsLoading: (isLoading: boolean) => void
) => {
  const [hostedDisclosures, setHostedDisclosures] = useState<HostedDisclosureType[]>(existingDisclosures || [])
  const [logoURL, setLogoURL] = useState<string | undefined>(undefined)
  const [integrationDisplayName, setIntegrationDisplayName] = useState<string | undefined>(undefined)
  const [formJSON, setFormJSON] = useState<FormJSONType | null>(null)
  const [projectPreview, setProjectPreview] = useState<ProjectPreviewForApplicationType | null>(null)

  const translate = useTranslate()
  const notify = useNotify()

  const fetchDisclosures = () => {
    setIsLoading(true)
    restClientInstance('CUSTOM_GET', 'custom', {
      url: `orgs/${orgId}/projects/${projectId}/systems/${systemUuid}/${paymentOptionId}/hosted_credit_app/?integration=${integration}`,
    })
      .then((response: DisclosuresResponseType) => {
        if (response?.data?.success) {
          setHostedDisclosures(response?.data?.disclosures)
          setLogoURL(response?.data?.logo_url)
          setIntegrationDisplayName(response?.data?.integration_display_name)
          setFormJSON(response?.data?.form_json)
          setProjectPreview(response?.data?.project)
        }
      })
      .catch((err) => {
        if (err?.body?.message) {
          notify(translate(err.body.message), 'warning')
          logAmplitudeEvent('integrated_finance_application_open_error', {
            integration: integration,
          })
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  useEffect(() => {
    if (!existingDisclosures) {
      fetchDisclosures()
    }
  }, [orgId, projectId, systemUuid, paymentOptionId, integration, existingDisclosures])

  return { hostedDisclosures, logoURL, integrationDisplayName, formJSON, projectPreview }
}
